import React, { useState } from 'react';
import { MissionBlock } from '../../Components/UserInfo/MissionBlock';
import { DistanceStats } from '../../Components/UserInfo/DistanceStats';
import { Container } from '@/frontend/components/Share/Components/UserInfo/Container';
const UserDistance = (props) => {
    const { data: { mission, distance, user, conqFlagImage }, } = props;
    const [isImageLoadFailed, setIsImageLoadFailed] = useState(false);
    return (React.createElement(Container, { conqFlagImage: conqFlagImage, dateCreated: distance.dateCreated, firstName: user.firstName, textColor: '#030303', userAvatar: user.userAvatar },
        React.createElement(MissionBlock, { mission: mission }),
        React.createElement(DistanceStats, { distance: distance, mission: mission }),
        React.createElement("div", { className: 'block block-distance' },
            React.createElement("div", { className: 'block-distance-content' },
                React.createElement("div", { className: 'block-distance-item' },
                    React.createElement("svg", { className: 'bi distance-route-icon', fill: 'currentColor', style: { color: mission.color1 } },
                        React.createElement("use", { xlinkHref: distance.travelledImageSvg })),
                    React.createElement("p", null, distance.travelledText)),
                React.createElement("div", { className: 'block-distance-separator' }),
                React.createElement("div", { className: 'block-distance-item' },
                    React.createElement("svg", { className: 'bi distance-exercise-icon', fill: 'currentColor', style: { color: mission.color1 } },
                        React.createElement("use", { xlinkHref: distance.exerciseTypeImageSvg })),
                    React.createElement("p", null, distance.exerciseTypeName)))),
        React.createElement(React.Fragment, null, distance.mapImage !== '' && !isImageLoadFailed && (React.createElement("div", { className: 'block-map' },
            React.createElement("img", { src: distance.mapImage, 
                // Image can fail to load for many reasons
                // Eg. Mapbox api is offline, image url is too large
                onError: () => setIsImageLoadFailed(true) }))))));
};
export { UserDistance };
